import moment from "moment";

export const updateObject = (oldObject, updatedProperties) => {
  return {
    ...oldObject,
    ...updatedProperties,
  };
};

export const checkValidity = (value, rules) => {
  let isValid = true;
  if (!rules) {
    return true;
  }

  if (rules.required) {
    isValid = value !== null && value.toString().trim() !== "" && isValid;
  }

  if (rules.minLength && value !== "") {
    isValid = value.length >= rules.minLength && isValid;
  }

  if (rules.maxLength && value !== "") {
    isValid = value.length <= rules.maxLength && isValid;
  }

  if (rules.isEmail && value !== "") {
    const pattern = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
    isValid = pattern.test(value) && isValid;
  }

  if (rules.isNumeric && value !== "") {
    const pattern = /^\d+$/;
    isValid = pattern.test(value) && isValid;
  }

  if (rules.isEuro && value !== "") {
    const pattern = /^(?!(?:[^,\n]*[,]){2})\d+(?:[,]\d+)?(?:[^\S\n\r]\d+(?:[,]\d+)?)*$/;
    isValid = value !== "" && pattern.test(value);
  }

  return isValid;
};

export const getCurrentDate = () => {
  var d = new Date(),
    month = "" + (d.getMonth() + 1),
    day = "" + d.getDate(),
    year = d.getFullYear();

  if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;

  return [year, month, day].join("-");
};

export const getDate = (date) => {
  const _date = moment(date, "YYYY-MM-DD");
  return _date.toDate();
};

// convert date YYYY-MM-DD to DD/MM/YYYY
export const getFrontDate = (date) => {
  const _date = moment(date, "YYYY-MM-DD").format("DD/MM/YYYY");
  return _date;
};

export const mergeDossierFormData = (formType, dossier, formData) => {
  let currentDossier = {};

  switch (formType) {
    case "BienForm":
      currentDossier = { ...dossier };
      if (dossier.biens !== undefined && dossier.biens.length > 0) {
        const findBienKey = dossier.biens.find(
          (bien) => bien.id === formData.id
        );
        if (findBienKey && findBienKey.id >= 0) {
          let biens = [...currentDossier.biens];
          biens.forEach((bien, index) => {
            if (bien.id === formData.id) {
              let _bien = { ...biens[index] };
              Object.keys(formData).forEach((item) => {
                _bien[item] = formData[item];
              });
              biens[index] = _bien;
            }
          });
          currentDossier.biens = biens;
        } else {
          currentDossier.biens = [...currentDossier.biens, formData];
        }
      } else {
        currentDossier.biens = [formData];
      }
      break;

    case "BienFormStep2":
      currentDossier = { ...dossier };
      if (dossier.biens !== undefined && dossier.biens.length > 0) {
        let biens = [...currentDossier.biens];
        biens.forEach((bien, index) => {
          if (bien.id === formData.id) {
            biens[index] = { ...biens[index], infosExercice: formData };
          }
        });
        currentDossier.biens = biens;
      }
      break;

    default:
      break;
  }

  return currentDossier;
};

export const getEuro = (n) => {
  let formattedEuro = "";
  if (typeof n !== "undefined" && n !== "") {
    let number = n.toString().replace(/\s+/g, "").replace(".", ",");
    if (number.includes(",")) {
      const num = number.split(",");
      formattedEuro =
        num[0].toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ") +
        "," +
        num[1].slice(0, 2);
    } else {
      formattedEuro = number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    }
  }
  return formattedEuro;
};

export const isFormReadOnly = (dossier) => {
  let isReadOnlyForm = false;
  const statuses = ["EnTraitement", "Termine"];

  if (dossier !== null) {
    if (dossier.status && statuses.includes(dossier.status)) {
      isReadOnlyForm = true;
    }
  }
  return isReadOnlyForm;
};

export const getFormErrors = (formElements) => {
  let errorsMessages = [
    "Un ou plusieurs champs obligatoires (marqués en rouge) sont à saisir.",
    "Si vous n'êtes pas concerné par un montant, mettre zéro.",
    "Un ou plusieurs champs obligatoires (marqués en rouge) ne sont pas au format attendu, merci de revoir votre saisie.",
  ];
  let errors = [];

  const caseOne = Object.keys(formElements).filter((key) => {
    return (
      !formElements[key].valid &&
      formElements[key].value === "" &&
      formElements[key].validation.required
    );
  });

  if (caseOne.length > 0) {
    errors.push(errorsMessages[0]);
  }

  const caseTwo = Object.keys(formElements).filter((key) => {
    return (
      !formElements[key].valid &&
      formElements[key].value === "" &&
      formElements[key].validation.required &&
      formElements[key].validation.isEuro
    );
  });

  if (caseTwo.length > 0) {
    errors.push(errorsMessages[1]);
  }

  const caseThree = Object.keys(formElements).filter((key) => {
    return (
      !formElements[key].valid &&
      formElements[key].value !== "" &&
      formElements[key].validation.required
    );
  });

  if (caseThree.length > 0) {
    errors.push(errorsMessages[2]);
  }

  return errors;
};
